// extracted by mini-css-extract-plugin
export default {"container":"styles_container__F1t3M","container__mobile":"styles_container__mobile__+t8iS"};